module.exports = __webpack_public_path__ + "static/media/ic-file-white.90646147.svg";